import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useNotification } from '../Contexts/NotificationContext';

const FeaturedItem = () => {
    const { setNotification } = useNotification();
    const [featured, setFeatured] = useState(null);
    const [loading, setLoading] = useState(true);

    const { slug } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchFeatured = async () => {
            try {
                const response = await fetch(`${baseUrl}/painel/destaques/${slug}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (response.ok) {
                    const data = await response.json();

                    setFeatured(data.destaque);
                } else {
                    throw new Error('Erro ao buscar o case');
                }
            } catch (error) {
                setNotification({
                    type: 'error',
                    message: error.message,
                    show: true,
                });
            } finally {
                setLoading(false);
            }
        };

        fetchFeatured();
    }, []);

    if (loading) return;

    return (
        <div className="-mt-14">
            <div className="relative z-[1] mb-20 before:content-[''] before:absolute before:top-0 before:bottom-0 before:w-screen before:left-1/2 before:bg-quaternary before:-translate-x-1/2 before:-z-[1]">
                <div className="flex flex-col py-10">
                    <div className="flex items-center">
                        <Link
                            to="/painel/news/destaques"
                            className="text-lg text-white font-medium uppercase tracking-wider -mb-2 transition-all hover:opacity-75"
                        >
                            Destaques
                        </Link>

                        <Link
                            to="/painel/news/destaques"
                            className="ml-auto px-5 py-1.5 flex items-center text-white uppercase gap-3 tracking-wider border border-white rounded-full transition-all hover:bg-white hover:text-tertiary"
                        >
                            <svg
                                width="24.2"
                                height="16"
                                viewBox="0 0 24.2 16"
                                className="fill-secondary"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M23.2,7H3.4l4.7-4.7c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0L0.3,7.3C0.2,7.4,0.1,7.5,0.1,7.6
                                    C0,7.7,0,7.9,0,8c0,0,0,0,0,0s0,0,0,0c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3l6.4,6.4c0.4,0.4,1,0.4,1.4,0
                                    c0.4-0.4,0.4-1,0-1.4L3.4,9h19.7c0.6,0,1-0.4,1-1S23.7,7,23.2,7z"
                                />
                            </svg>

                            <span className="max-md:hidden">Voltar</span>
                        </Link>
                    </div>
                    <h2 className="text-[44px] text-secondary font-semibold">{featured.titulo}</h2>
                </div>
            </div>

            <img src={featured.imagem} alt={featured.titulo} className="block w-full" />

            <h4 className="text-2xl text-white font-semibold mt-10">{featured.previa}</h4>
            {featured.publicado && <h6 className="text-sm text-white italic opacity-50">Publicado em {featured.publicado}</h6>}

            <div className="text-white [&_ol]:list-decimal [&_li_+_li]:mt-2 [&_ul]:list-disc [&_ol]:pl-6 [&_ul]:pl-6 [&_li[data-list=bullet]]:list-disc [&_p]:mt-2 mt-10 mb-4" dangerouslySetInnerHTML={{ __html: featured.conteudo }} />
        </div>
    );
};

export default FeaturedItem;
